import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Primary pill CTA in copper; secondary in forest outline.
export const CTAButton = ({
  children = "Start Free Assessment",
  to = "/assessment",
  variant = "copper",
  onClick,
  className = "",
  icon = true,
  size = "md",
  testId = "cta-button",
  ...rest
}) => {
  const navigate = useNavigate();
  const handle = (e) => {
    if (onClick) return onClick(e);
    if (to) navigate(to);
  };

  const base =
    "group inline-flex items-center whitespace-nowrap rounded-full font-medium tracking-tight transition-[transform,background-color,color,border-color] duration-300 will-change-transform active:scale-[0.98]";
  const sizes = {
    md: "gap-2.5 px-7 py-3.5 text-[15px]",
    sm: "gap-2 px-4 py-3 text-sm",
  };
  const styles = {
    copper:
      "bg-sa-copper text-white hover:bg-sa-copper-deep hover:scale-[1.03] shadow-[0_10px_30px_-8px_rgba(198,123,92,0.5)]",
    forest:
      "bg-sa-forest text-white hover:bg-sa-forest-soft hover:scale-[1.03]",
    ghost:
      "bg-transparent text-sa-forest border border-sa-forest/20 hover:border-sa-forest/50 hover:scale-[1.02]",
    light:
      "bg-white text-sa-forest hover:scale-[1.03] shadow-[0_10px_30px_-8px_rgba(10,46,34,0.25)]",
  };

  return (
    <button
      onClick={handle}
      data-testid={testId}
      className={`${base} ${sizes[size]} ${styles[variant]} ${className}`}
      {...rest}
    >
      <span>{children}</span>
      {icon && (
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </button>
  );
};

export default CTAButton;
